import {
    CustomButton,
    CustomModal,
    showToast,
} from "components/Common"
import { ModalBody, ModalFooter } from "reactstrap"
import { withTranslation } from "react-i18next"
import { useEffect } from "react"

const ErrorLogModal = ({
    modal,
    toggle,
    data,
    t,
}) => {
    const title = 'Messge'

    useEffect(() => {
        Prism.highlightAll();
    }, [])

    const copyMessage = () => {
        navigator.clipboard.writeText(data.messageDetail)
        showToast(
            `${t("message:Succeeded", {
                field: `${t("common:Copy")}`,
            })}`
        )
    }

    return (
        <CustomModal modal={modal} title={title} onToggle={toggle} size="lg">
            <ModalBody className="requestModal">
                <span>{data.messageDetail}</span>
            </ModalBody>
            <ModalFooter>
                <CustomButton
                    text={t("common:Copy")}
                    type="button"
                    color="primary"
                    onClick={copyMessage}
                    data-dismiss="modal"
                    className="button-width"
                />
                <CustomButton
                    text={t("common:Ok")}
                    type="button"
                    color="primary"
                    onClick={toggle}
                    data-dismiss="modal"
                    className="button-width"
                />
            </ModalFooter>
        </CustomModal>
    )
}

ErrorLogModal.propTypes = {
}

export default withTranslation(["AuditLog", "common"])(ErrorLogModal)